import script from "./SceneDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./SceneDialog.vue?vue&type=script&setup=true&lang=js"

import "./SceneDialog.vue?vue&type=style&index=0&id=33d2ac03&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33d2ac03"]])

export default __exports__